import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { trackByProp } from '@recruitee/common';
import { Attribute, AttributeListData } from '@recruitee/http/types';

import { TranslationsContextType } from '../attributes.types';

@Component({
  selector: 'rt-input-attributes',
  templateUrl: 'input-attributes.component.html',
  styleUrls: ['./input-attributes.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputAttributesComponent implements OnChanges {
  @Input() public selectedAttributes: Attribute[] = [];
  @Input() public filteredAttributes: Attribute[] = [];
  @Input() public placeholder: string;
  @Input() public hasClearButton: boolean = true;
  @Input() public noRightPadding: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public max: number | null = null;
  @Input() public translationsContext: TranslationsContextType;

  @Output() public save: EventEmitter<Attribute> = new EventEmitter();
  @Output() public query: EventEmitter<string> = new EventEmitter();
  @Output() public deleteAttribute: EventEmitter<Attribute> = new EventEmitter();
  @Output() public clearAll: EventEmitter<void> = new EventEmitter();

  public toggle: boolean = false;
  public trackById = trackByProp<Attribute>({ prop: 'id' });
  public suggestionsData: AttributeListData = { isLoading: false, meta: null, rows: [] };

  constructor(protected cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('filteredAttributes' in changes) {
      this.suggestionsData = {
        meta: {
          page: 1,
          limit: this.filteredAttributes.length,
          totalCount: this.filteredAttributes.length,
        },
        rows: this.filteredAttributes,
        isLoading: false,
      };
    }
  }

  public onSave(attr: Attribute): void {
    if (this.max === null || this.max > this.selectedAttributes.length) {
      this.save.emit(attr);
    }

    this.toggle = !this.toggle;
    this.cdRef.detectChanges();
  }

  public handleClearAll(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.clearAll.emit();
    }
  }
}
